<template>
    <Card :title="$t('labels.create_tag')">
        <div class="card-body">
            <FormGroup :label="$t('labels.name')" >
                <Input v-model="tagName" />
            </FormGroup>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton @click="createTag" color="indigo">
                {{ $t("buttons.create") }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../services/HttpClient";

export default {
    name: 'CreateTagsCard',
    components: {
        Card, FormGroup, Input, AppButton
    },
    data() {
        return {
            tagName: ''
        }
    },
    methods: {
        createTag() {
            httpClient.post(`/integration-product-tags`, {
                name: this.tagName
            }).then(() => {
                this.$router.push({name: 'TagsCard'});
            });
        }
    }
};
</script>